class HistoryStack {
  stack = [];
  cursor = -1;
  end = -1;

  get length() {
    return this.end + 1;
  }

  push(state) {
    this.cursor++;
    this.end = this.cursor;
    this.stack[this.cursor] = state;
  }

  back() {
    if (this.length < 1) {
      return null;
    }

    this.cursor--;
    return this.stack[this.cursor];
  }

  forward() {
    const dest = this.cursor + 1;

    if (dest > this.length || dest < 0) {
      return null;
    }

    this.cursor = dest;
    return this.stack[this.cursor];
  }

  peek() {
    if (this.length < 1) {
      return null;
    }

    return this.stack[this.cursor];
  }

  hasNext() {
    return this.cursor !== this.end;
  }

  hasPrevious() {
    return this.cursor >= 1;
  }
}

export default HistoryStack;